import { TranslateService } from '@ngx-translate/core';

const CODE_TO_KEY: Record<string, string> = {
  'auth/invalid-email': 'auth.errors.firebase.invalidEmail',
  'auth/user-not-found': 'auth.errors.firebase.userNotFound',
  'auth/wrong-password': 'auth.errors.firebase.wrongPassword',
  'auth/invalid-credential': 'auth.errors.firebase.invalidCredential',
  'auth/email-already-in-use': 'auth.errors.firebase.emailAlreadyInUse',
  'auth/weak-password': 'auth.errors.firebase.weakPassword',
  'auth/user-disabled': 'auth.errors.firebase.userDisabled',
  'auth/popup-closed-by-user': 'auth.errors.firebase.popupClosedByUser',
  'auth/popup-blocked': 'auth.errors.firebase.popupBlocked',
  'auth/cancelled-popup-request': 'auth.errors.firebase.cancelledPopupRequest',
  'auth/network-request-failed': 'auth.errors.firebase.networkRequestFailed',
  'auth/too-many-requests': 'auth.errors.firebase.tooManyRequests',
  'auth/operation-not-allowed': 'auth.errors.firebase.operationNotAllowed',
  'auth/requires-recent-login': 'auth.errors.firebase.requiresRecentLogin',
  'auth/account-exists-with-different-credential': 'auth.errors.firebase.accountExistsWithDifferentCredential'
};

export class FirebaseAuthError extends Error {
  readonly code: string | null;

  constructor(message: string, code: string | null) {
    super(message);
    this.name = 'FirebaseAuthError';
    this.code = code;
  }
}

export const getFirebaseAuthErrorMessage = (code: string | undefined | null, translate: TranslateService): string => {
  if (!code) {
    return translate.instant('auth.errors.unknown');
  }
  const key: string | undefined = CODE_TO_KEY[code];
  if (key) return translate.instant(key);
  return translate.instant('auth.errors.unknownWithCode', { code });
};

export const buildFirebaseAuthError = (
  err: { code?: string; message?: string },
  translate: TranslateService
): FirebaseAuthError => {
  const code: string | null = err.code ?? null;
  const message: string =
    getFirebaseAuthErrorMessage(code, translate) || err.message || translate.instant('auth.errors.unknown');
  return new FirebaseAuthError(message, code);
};
